import { render, staticRenderFns } from "./InsLayer.vue?vue&type=template&id=0022c04a&scoped=true"
import script from "./InsLayer.vue?vue&type=script&lang=ts"
export * from "./InsLayer.vue?vue&type=script&lang=ts"
import style0 from "./InsLayer.vue?vue&type=style&index=0&id=0022c04a&prod&lang=less"
import style1 from "./InsLayer.vue?vue&type=style&index=1&id=0022c04a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0022c04a",
  null
  
)

export default component.exports